/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for SamirPayHookCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class SamirPayHookCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    samirPayHook(transactionId: string, orderId: string, status: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    samirPayHook(transactionId: string, orderId: string, status: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    samirPayHook(transactionId: string, orderId: string, status: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    samirPayHook(transactionId: string, orderId: string, status: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/samirpay`;

        let params = new HttpParams();
        if (transactionId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, transactionId, 'transaction_id');
        }
        if (orderId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, orderId, 'order_id');
        }
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    samirPayHook1(transactionId: string, orderId: string, status: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    samirPayHook1(transactionId: string, orderId: string, status: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    samirPayHook1(transactionId: string, orderId: string, status: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    samirPayHook1(transactionId: string, orderId: string, status: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/samirpay`;

        let params = new HttpParams();
        if (transactionId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, transactionId, 'transaction_id');
        }
        if (orderId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, orderId, 'order_id');
        }
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    samirPayHook2(transactionId: string, orderId: string, status: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    samirPayHook2(transactionId: string, orderId: string, status: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    samirPayHook2(transactionId: string, orderId: string, status: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    samirPayHook2(transactionId: string, orderId: string, status: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/samirpay`;

        let params = new HttpParams();
        if (transactionId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, transactionId, 'transaction_id');
        }
        if (orderId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, orderId, 'order_id');
        }
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    samirPayHook4(transactionId: string, orderId: string, status: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    samirPayHook4(transactionId: string, orderId: string, status: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    samirPayHook4(transactionId: string, orderId: string, status: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    samirPayHook4(transactionId: string, orderId: string, status: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/samirpay`;

        let params = new HttpParams();
        if (transactionId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, transactionId, 'transaction_id');
        }
        if (orderId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, orderId, 'order_id');
        }
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    samirPayHook3(transactionId: string, orderId: string, status: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    samirPayHook3(transactionId: string, orderId: string, status: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    samirPayHook3(transactionId: string, orderId: string, status: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    samirPayHook3(transactionId: string, orderId: string, status: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/samirpay`;

        let params = new HttpParams();
        if (transactionId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, transactionId, 'transaction_id');
        }
        if (orderId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, orderId, 'order_id');
        }
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    samirPayHook6(transactionId: string, orderId: string, status: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    samirPayHook6(transactionId: string, orderId: string, status: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    samirPayHook6(transactionId: string, orderId: string, status: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    samirPayHook6(transactionId: string, orderId: string, status: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/samirpay`;

        let params = new HttpParams();
        if (transactionId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, transactionId, 'transaction_id');
        }
        if (orderId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, orderId, 'order_id');
        }
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    samirPayHook5(transactionId: string, orderId: string, status: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    samirPayHook5(transactionId: string, orderId: string, status: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    samirPayHook5(transactionId: string, orderId: string, status: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    samirPayHook5(transactionId: string, orderId: string, status: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/samirpay`;

        let params = new HttpParams();
        if (transactionId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, transactionId, 'transaction_id');
        }
        if (orderId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, orderId, 'order_id');
        }
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
